// src/App.js
import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";

import { HelpProvider } from "./context/HelpProvider";
import { AuthProvider, VenueContext } from "./utils/authprovider";
import ProtectedRoute from "./utils/protectedRoutes";
import AppRoutes from "./routes";

import Dashboard              from "./pages/Dashboard";
import EmailVerificationPage   from "./pages/EmailVerificationPage";
import ChooseAccountPage       from "./pages/ChooseAccountPage";
import VenueSelection          from "./pages/VenueSelection";
import FindVenues              from "./pages/FindVenues";
import ParameterChoice         from "./pages/ParameterChoice";
import TagsMatching            from "./pages/TagsMatching";
import Distance                from "./pages/Distance";
import Preferences             from "./pages/Preferences";
import MatchingFlow            from "./pages/MatchingFlow";
import BusinessPlan            from "./pages/BusinessPlan";
import PaymentSuccess          from "./pages/PaymentSuccess";
import PaymentFailure          from "./pages/PaymentFailure";
import PaymentUpdateSuccess    from "./pages/PaymentUpdateSuccess";
import PaymentUpdateFailure    from "./pages/PaymentUpdateFailure";
import SettingsPage            from "./pages/SettingsPage";
import AddVenue                from "./pages/AddVenue";
import TrackerPage             from "./pages/TrackerPage";
import HelpDocs                from "./pages/HelpDocs";

import "./App.css";

/* ── Lightweight GA4 page-view tracker ─────────────────────────── */
function HeadlessAnalytics() {
  const location = useLocation();
  useEffect(() => {
    if (window.gtag) {
      window.gtag("config", "G-GZMT8X6QWZ", {
        page_path: location.pathname + location.search,
      });
    }
  }, [location]);
  return null;
}
/* ──────────────────────────────────────────────────────────────── */

function App() {
  const [activeVenue] = useState(null);

  /* Only set the tab title now; favicon is handled by index.html */
  useEffect(() => {
    document.title = "BestDay2Marry";
  }, []);

  return (
    <Router>
      <AuthProvider>
        <HelpProvider>
          <HeadlessAnalytics />

          <VenueContext.Provider value={activeVenue}>
            {/* ─── Public marketing + auth pages ─── */}
            <AppRoutes />

            {/* ─── Protected, user-specific area ─── */}
            <Routes>
              <Route element={<ProtectedRoute />}>
                <Route path="/find_venues/:user_id"            element={<FindVenues />} />
                <Route path="/parameters/:user_id"             element={<ParameterChoice />} />
                <Route path="/tags_matching/:user_id"          element={<TagsMatching />} />
                <Route path="/distance/:user_id"               element={<Distance />} />
                <Route path="/preferences/:user_id"            element={<Preferences />} />

                <Route path="/couples_plans/:user_id"          element={<MatchingFlow />} />
                <Route path="/business_plans/:user_id"         element={<BusinessPlan />} />

                <Route path="/payment_success/:user_id"        element={<PaymentSuccess />} />
                <Route path="/payment_failure/:user_id"        element={<PaymentFailure />} />
                <Route path="/payment_update_success/:user_id" element={<PaymentUpdateSuccess />} />
                <Route path="/payment_update_failure/:user_id" element={<PaymentUpdateFailure />} />

                <Route path="/venue_selection/:user_id"        element={<VenueSelection />} />
                <Route path="/add_venue/:user_id"              element={<AddVenue />} />

                <Route path="/user_verification/:user_id"      element={<EmailVerificationPage />} />
                <Route path="/choose_account/:user_id"         element={<ChooseAccountPage />} />

                <Route path="/tracker/:user_id"                element={<TrackerPage />} />
                <Route path="/dashboard/:user_id/*"            element={<Dashboard />} />
                <Route path="/help/:userId"                    element={<HelpDocs />} />
                <Route path="/settings/:user_id/*"             element={<SettingsPage />} />
              </Route>
            </Routes>
          </VenueContext.Provider>
        </HelpProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;